import { useNavigate } from "react-router-dom";
import Card from "../../component/common/Card";
import { useUser } from "../../context/UserContext";
import { useEffect, useState } from "react";
import httpServices from "../../services/httpServices";
import CustomSelect from "../../component/common/CustomSelect";

function Events() {
  const navigate = useNavigate();
  const [allEventsData, setAllEventsData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const { isSimpleUser } = useUser();
  const { user } = useUser();

  const getAllEvents = async () => {
    try {
      const { response, error } = await httpServices.get(
        isSimpleUser
          ? `/event/list?page=1&size=10`
          : `/event/byVendorId/${user?.userId}?page=1&size=10`
      );
      if (error) {
        throw error;
      }
      if (response.status === 200) {
        const events = response.data?.data?.events || [];
        setAllEventsData(events);
        setEventsData(events);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    let filteredData = allEventsData;

    if (statusFilter === "Completed") {
      filteredData = filteredData?.filter((event) => event.eventStatus === 1);
    } else if (statusFilter === "In Progress") {
      filteredData = filteredData?.filter((event) => event.eventStatus !== 1);
    }

    if (searchFilter) {
      filteredData = filteredData?.filter((event) =>
        event.eventName.toLowerCase().includes(searchFilter.toLowerCase())
      );
    }

    setEventsData(filteredData);
  }, [statusFilter, searchFilter, allEventsData]);

  useEffect(() => {
    getAllEvents();
  }, []);

  const handleAddEvent = () => {
    navigate("/events/add-events");
  };

  const handleStatusFilter = (selectedOption) => {
    setStatusFilter(selectedOption);
  };

  const handleSearchFilterChange = (e) => {
    setSearchFilter(e.target.value);
  };
  console.log("event data", eventsData);

  return (
    <div className=" pt-[16px] w-[90%] ">
      {!isSimpleUser && (
        <div className="flex items-start flex-wrap justify-between gap-3 ">
          <div className="flex gap-2 sm:gap-4  ">
            <div className="relative flex w-full xs:w-[300px] items-center">
              <input
                type="text"
                placeholder="Search Events"
                className="custom-input rounded-[10px] w-full"
                value={searchFilter}
                onChange={handleSearchFilterChange}
              />
              <div className="absolute right-5">
                <img src="/images/search.svg" alt="icon" />
              </div>
            </div>
            <div className="w-50 z-[9999]">
              <CustomSelect
                options={[
                  { value: "", label: "Select Status", color: "#94A3B8" },
                  { value: "Completed", label: "Completed", color: "#176CED" },
                  {
                    value: "In Progress",
                    label: "In Progress",
                    color: "#807BFF",
                  },
                ]}
                onChange={(selectedOption) => {
                  handleStatusFilter(selectedOption);
                }}
                value={statusFilter}
                placeholder={"Select Capacity"}
              />
            </div>
          </div>

          <button
            onClick={handleAddEvent}
            className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-[10px] bg-gradient-to-t from-[#2E3E8D] to-[#4DB1E1]"
          >
            <span className="relative px-[11px] py-2  bg-[#F5F6FA] rounded-[8px] flex items-center gap-[6px]">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 1.5V13.5"
                  stroke="url(#paint0_linear_157_1826)"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 7.5H13"
                  stroke="url(#paint1_linear_157_1826)"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_157_1826"
                    x1="7.325"
                    y1="13.5"
                    x2="7.325"
                    y2="1.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#2E3E8D" />
                    <stop offset="1" stopColor="#4DB1E1" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_157_1826"
                    x1="4.9"
                    y1="8.5"
                    x2="4.9"
                    y2="7.5"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#2E3E8D" />
                    <stop offset="1" stopColor="#4DB1E1" />
                  </linearGradient>
                </defs>
              </svg>

              <span className="bg-clip-text text-transparent bg-gradient-to-t from-[#2E3E8D] text-sm to-[#4DB1E1]">
                Add Events
              </span>
            </span>
          </button>
        </div>
      )}

      <div
        className={`${
          isSimpleUser ? "my-0" : "my-[16px]"
        } grid sm:grid-cols-2 grid-cols-1   lg:grid-cols-3 xl:grid-cols-4 gap-[25px]`}
      >
        {eventsData?.map((event) => (
          <Card
            isEventCard={true}
            id={event.id}
            title={event.eventName}
            images={event.eventMedia || ["1700071403013.jpg"]}
            location={event.location}
            date={event.eventDate}
            key={event.id}
          />
        ))}
      </div>
    </div>
  );
}

export default Events;
